module.exports = __webpack_public_path__ + "img/adon.9c6935e2.jpg";